// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1iu_2","search":"Settings_search__1cOi3","filter":"Settings_filter__qZpGg"};